import React, { useState } from 'react';
import { CardContent, Typography, Divider } from '@mui/material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { SetPasswordControl } from '../../components/SetPasswordControl/SetPasswordControl';

type Props = {
    password?: string;
    changePassword?: Function;
    changeNextEnabled?: Function;
    changeNextLabel?: Function;
};

export const SetPassword: React.FC<Props> = (props: Props) => {
    const { t } = useLanguageLocale();

    const { password, changePassword, changeNextEnabled, changeNextLabel } = props;
    const [passwordValid, setPasswordsValid] = useState(false);

    if (changeNextEnabled) {
        changeNextEnabled(passwordValid);
    }
    if (changeNextLabel) {
        changeNextLabel(t('ACTIONS.NEXT'));
    }

    return (
        <>
            <CardContent style={{ flex: '1 1 0px', overflow: 'auto' }}>
                <Typography variant="body2" component="p" style={{ marginBottom: 50 }}>
                    {t('CHANGE_PASSWORD.PASSWORD_INFO')}
                </Typography>
                <Divider style={{ margin: '30px 0px' }} />
                <SetPasswordControl
                    password={password}
                    passwordValidate={(value: boolean): void => setPasswordsValid(value)}
                    onPasswordChange={(newPassword: string): void => {
                        if (changePassword) {
                            changePassword(newPassword);
                        }
                    }}
                />
            </CardContent>
        </>
    );
};
